import * as React from 'react';
import { useDrag } from 'react-dnd';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import get from 'lodash.get';

// Global Actions
import { updateHarvestEventTimeline } from 'services/harvestEvents/actions';

// Global Selectors
import { makeSelectHarvestQuantitySchedulesCount } from 'services/harvestEvents/selectors';

// Constants
import { EVENT_TIMELINE_CELL } from '../../../../../../../../../../constants';

interface Props {
    harvestEventUuid: string;
    groupId: number;
    children: React.Node;
    quantitySchedulesCount?: number;
    updateHarvestEventTimeline: Function;
}

export const EventsTimelineEventDragSource = (props: Props) => {
    // Ref used for getting the width of the event timeline item
    const ref = React.useRef(null);

    const {
        harvestEventUuid,
        groupId,
        children,
        quantitySchedulesCount,
        ...rest
    } = props;
    const [{ isDragging }, drag] = useDrag({
        type: EVENT_TIMELINE_CELL,
        item: () => {
            const elementWidth = get(ref, ['current', 'offsetWidth'], 0) + 1;
            return {
                id: harvestEventUuid,
                width: quantitySchedulesCount * elementWidth,
                groupId
            };
        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (item && dropResult) {
                const { nextGroupId, date } = dropResult;
                rest.updateHarvestEventTimeline(
                    item.id,
                    groupId,
                    nextGroupId,
                    date
                );
            }
        },
        collect: monitor => ({
            isDragging: monitor.isDragging()
        })
    });
    return (
        <div
            ref={drag}
            style={{
                opacity: isDragging ? 0.5 : 1
            }}
        >
            <div className="events-timeline-event-drag-source" ref={ref}>
                {children}
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    quantitySchedulesCount: makeSelectHarvestQuantitySchedulesCount()
});

export default connect(
    mapStateToProps,
    { updateHarvestEventTimeline }
)(EventsTimelineEventDragSource);
